// extracted by mini-css-extract-plugin
export default {"editSingleRequestContainer":"EditSingleCallOfRegistrationRequest_editSingleRequestContainer__uSdYR"};